"use client";

import { Core } from "@faire/design-tokens";
import { useIsEligibleForMobileLoggedOutNavWithCartSignUp } from "@faire/retailer-visitor-shared/components/Header/__internal__/useIsEligibleForMobileLoggedOutNavWithCartSignUp";
import { Button } from "@faire/web/slate/Button/Button";
import { Search } from "@faire/web/slate/icons/foundation/Search";
import React from "react";

import { useHeaderState } from "../useHeaderState";

export const MobileSearchIconButton: React.FC = () => {
  const { showMobileSearch } = useHeaderState();
  const shouldShowUpdatedMobileSearch =
    useIsEligibleForMobileLoggedOutNavWithCartSignUp();
  return shouldShowUpdatedMobileSearch ? (
    <Button
      variant="tertiary"
      onClick={showMobileSearch}
      data-test-id="mobile-search-button"
    >
      <Search
        margin="0 20px 0 0"
        height="20px"
        width="20px"
        color={Core.icon.default}
      />
    </Button>
  ) : null;
};
